import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const FadeUp = ({ children, delay = 0, className = "", y = 40, once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

// Masked line-by-line headline reveal — the signature MVM moment.
export const MaskedLines = ({ lines, className = "", lineClassName = "", delay = 0, as: Tag = "h1" }) => {
  const MotionTag = motion[Tag] || motion.h1;
  return (
    <MotionTag className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className={`block ${lineClassName}`}
            initial={{ y: "115%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.1, delay: delay + i * 0.14, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </MotionTag>
  );
};

// Clip-path lives on the img (variant-driven, not IO-observed) so Chromium's
// IntersectionObserver never sees a fully self-clipped target.
export const ImageReveal = ({ src, alt, className = "", imgClassName = "", delay = 0 }) => (
  <motion.div
    className={`overflow-hidden ${className}`}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, margin: "-60px" }}
    variants={{
      hidden: { opacity: 0 },
      visible: { opacity: 1, transition: { duration: 0.5, delay } },
    }}
  >
    <motion.img
      src={src}
      alt={alt}
      className={imgClassName}
      loading="lazy"
      variants={{
        hidden: { clipPath: "inset(100% 0 0 0)", scale: 1.25 },
        visible: {
          clipPath: "inset(0% 0 0 0)",
          scale: 1,
          transition: { duration: 1.4, delay, ease: EASE },
        },
      }}
    />
  </motion.div>
);
